import React from "react";
import GameCard from "./GameCard";

const CardFlex = ({ games, onToggleWishlist, formatCurrency }) => {
    return (
        <div className="flex flex-wrap justify-start gap-4">
            {games?.map((game) => (
                <div key={game.id} className="max-w-[16rem] mx-auto">
                    <GameCard
                        game={game}
                        onToggleWishlist={onToggleWishlist}
                        formatCurrency={formatCurrency}
                    />
                </div>
            ))}
        </div>
    );
};

export default CardFlex;
